/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";
import { AccountRequestInterface } from "@/data/payload/contracts/AccountRequest";
import { QueryParamsEntities } from "@/domain/entities/MainApp";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { AccountController } from '@/app/ui/controllers/AccountController';

export class EditEmailAccountRequest implements AccountRequestInterface {
  newEmail: string;
  token?: string;
  otp?: string;
  constructor(newEmail: string, token?: string, otp?: string) {
    this.newEmail = newEmail;
    this.token = token;
    this.otp = otp;
  }

  public toJSON() {
    return JSON.stringify({
      email: this.newEmail,
      token: this.token,
      otp: this.otp
    });
  }
}

export class PairTokenRequest implements AccountRequestInterface {
  token: string;
  accountId: number;
  constructor(token: string, accountId: number) {
    this.token = token;
    this.accountId = accountId;
  }
  public toJSON() {
    return JSON.stringify({
      token: this.token,
      account_id: this.accountId,
      hub_id: getHubData()?.hubId
    });
  }
}
export class UnpairTokenRequest implements AccountRequestInterface {
  accountId: number;
  constructor(accountId: number) {
    this.accountId = accountId;
  }

  public toJSON() {
    return JSON.stringify({
      account_id: this.accountId,
      hub_id: getHubData()?.hubId
    });
  }
}

export class DashboardDeliveryRequest {
  cache = false; // cache api
  constructor(fields?: Partial<DashboardDeliveryRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class PostCsAccountApiRequest implements AccountRequestInterface {
  action = "";
  constructor(fields?: Partial<PostCsAccountApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON() {
    return JSON.stringify(ConvertObjectCamelToSnakeCase(this));
  }
}

export class DeviceAuthReviewRequest implements AccountRequestInterface {
  deviceApprovalId: string;
  reviewType: "approve" | "reject";
  deviceIdApproval: string;

  constructor(deviceApprovalId: string, reviewType: "approve" | "reject", deviceIdApproval: string) {
    this.deviceApprovalId = deviceApprovalId;
    this.reviewType = reviewType;
    this.deviceIdApproval = deviceIdApproval;
  }

  public toJSON() {
    const payload = ConvertObjectCamelToSnakeCase(this);
    delete payload.device_id_approval
    return JSON.stringify(payload);
  }
}
